import { gql } from '../../__generated__';

gql(/* GraphQL */ `
  fragment TiptapDocumentVersionItem on TiptapDocumentVersion {
    documentVersion
    createdAt
    createdBy {
      subjectId
      name
    }
  }
`);

gql(/* GraphQL */ `
  fragment TiptapDocumentItem on TiptapDocument {
    documentName
    documentVersion
    createdAt
    createdBy {
      subjectId
      name
    }
    comment
    documentVersions {
      ...TiptapDocumentVersionItem
    }
  }
`);

export const GUIDE_CMS_INFO = gql(/* GraphQL */ `
  query GetGuideCmsInfo($id: UUID!) {
    guide(id: $id) {
      id
      docId
      docName
      docNumber
      docTitle
      citations {
        id
        text
      }
      tiptapDocument {
        ...TiptapDocumentItem
      }
      tiptapDocuments {
        ...TiptapDocumentItem
      }
      releases {
        id
        releaseNotes
        createdAt
        publicVersion
        guide {
          tiptapDocument {
            ...TiptapDocumentItem
          }
        }
      }
    }
  }
`);

export const CREATE_NEW_GUIDE_CONTENT_VERSION = gql(/* GraphQL */ `
  mutation GuideCreateNewContentVersion($input: GuideCreateNewContentVersionInput!) {
    guideCreateNewContentVersion(input: $input) {
      guideModel {
        id
        hasChangesSinceLastPublish
        tiptapDocument {
          ...TiptapDocumentItem
        }
        guideLinks {
          id
        }
        standards {
          id
        }
      }
    }
  }
`);

export const CREATE_NEW_GUIDE_CONTENT_DOCUMENT = gql(/* GraphQL */ `
  mutation GuideCreateNewContentDocument($input: GuideCreateNewContentDocumentInput!) {
    guideCreateNewContentDocument(input: $input) {
      guideModel {
        id
        hasChangesSinceLastPublish
        tiptapDocuments {
          ...TiptapDocumentItem
        }
        tiptapDocument {
          ...TiptapDocumentItem
        }
        guideLinks {
          id
        }
        standards {
          id
        }
      }
    }
  }
`);

export const DISCARD_GUIDE_DRAFT = gql(/* GraphQL */ `
  mutation GuideDiscardDraft($input: GuideDiscardDraftInput!) {
    guideDiscardDraft(input: $input) {
      importResult {
        success
      }
    }
  }
`);

export const IMPORT_LAST_PUBLISHED_VERSION = gql(/* GraphQL */ `
  mutation GuideImportLastPublishedVersion($input: GuideImportLastPublishedVersionInput!) {
    guideImportLastPublishedVersion(input: $input) {
      importResult {
        success
      }
    }
  }
`);

export const IMPORT_OTHER_PUBLISHED_VERSION = gql(/* GraphQL */ `
  mutation GuideImportOtherPublishedVersion($input: GuideImportOtherPublishedVersionInput!) {
    guideImportOtherPublishedVersion(input: $input) {
      importResult {
        success
      }
    }
  }
`);

export const IMPORT_WORD_DOCUMENT = gql(/* GraphQL */ `
  mutation GuideImportWordDocument($input: GuideImportWordDocumentInput!) {
    guideImportWordDocument(input: $input) {
      cmsWordImportResult {
        success
        imageCount
        diagnostics {
          code
          severity
          message
          paragraphIndex
          styleName
        }
      }
    }
  }
`);

export const GET_FIGURE_FILE_UPLOADED_AT = gql(/* GraphQL */ `
  query GuideFigureFileUploadedAt($guideId: UUID!, $figureId: UUID!, $fileId: UUID!, $fileName: String!, $fileType: FigureFileType!) {
    guideFigureFileUploadedAt(guideId: $guideId, figureId: $figureId, fileId: $fileId, fileName: $fileName, fileType: $fileType)
  }
`);

export const UPLOAD_FIGURE = gql(/* GraphQL */ `
  mutation UploadGuideFigureFile($input: GuideUploadFigureFileInput!) {
    guideUploadFigureFile(input: $input) {
      figureFile {
        id
        figureId
        type
        metadata {
          name
          value
        }
        fileName
      }
    }
  }
`);

export const UPLOAD_ATTACHMENT = gql(/* GraphQL */ `
  mutation UploadGuideAttachmentFile($input: GuideUploadAttachmentFileInput!) {
    guideUploadAttachmentFile(input: $input) {
      attachmentFile {
        id
        filename
      }
    }
  }
`);
